// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mFuVg6xVHW4V_Ur3Z1TG{flex-direction:column;height:100%;padding:16px 0 32px;display:flex}.zQxW5O6rP8390bQ4FhfN{padding:14px 24px 22px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `mFuVg6xVHW4V_Ur3Z1TG`,
	"status": `zQxW5O6rP8390bQ4FhfN`
};
export default ___CSS_LOADER_EXPORT___;
